<template>
  <v-select
    v-model="model"
    :items="items"
    :label="label"
    :placeholder="placeholder"
    :error="error"
    :error-messages="errorMessages"
    :density="density"
    :variant="variant"
    @update:model-value="handleUpdate"
  >
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps" />
    </template>
  </v-select>
</template>

<script>
export default {
  name: "RbSelect",

  props: {
    modelValue: [String, Number, Object],
    items: {
      type: Array,
      default: () => [],
    },
    label: String,
    placeholder: String,
    error: Boolean,
    errorMessages: Array,
    density: {
      type: String,
      default: "compact",
    },
    variant: {
      type: String,
      default: "outlined",
    },
  },

  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },

  emits: ["update:modelValue", "change"],

  methods: {
    handleUpdate(value) {
      this.$emit("update:modelValue", value);
      this.$emit("change", value);
    },
  },
};
</script>

<style scoped>
::v-deep(.v-field__input) {
  font-size: 13px;
}
::v-deep(.v-label) {
  font-size: 12px !important;
}
::v-deep(.v-field-label) {
  font-size: 11px !important;
}
:deep(.v-chip) {
  background-color: #eef2ff;
  color: #4338ca;
  font-weight: 500;
}

:deep(.v-chip__close) {
  color: #4338ca;
}
</style>